const Keys = {
  REDIRECT_URL_KEY:
    process.env.REDIRECT_URL_KEY || 'lklskdjk283928298Ulksldkluryo72',
};

export default Keys;
